import { render, staticRenderFns } from "./seleccionado.vue?vue&type=template&id=f9404f30&scoped=true"
import script from "./seleccionado.vue?vue&type=script&lang=js"
export * from "./seleccionado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9404f30",
  null
  
)

export default component.exports